import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=0da45658"
import script from "./Render.vue?vue&type=script&lang=js"
export * from "./Render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports